<template >
  <div>
    <!-- 查询表单 start-->
    <div class="main_form">
      <el-form :inline="true" :model="queryModel" size="small" ref="queryForm">
        <el-form-item class="search_form_item" prop="userId">
          <el-input v-model.trim="queryModel.userId" :placeholder="$t('m.live_ID')" clearable></el-input>
        </el-form-item>
        <el-form-item class="search_form_item" prop="remark">
          <el-input v-model="queryModel.remark" :placeholder="$t('m.remark')" maxlength="200" clearable filterable></el-input>
        </el-form-item>
        <el-form-item class="search_form_item" prop="contractStatus">
          <el-select v-model="queryModel.contractStatus" :placeholder="$t('m.sign_status')" clearable>
            <el-option :value="1" :label="$t('m.sign_ing')"></el-option>
            <el-option :value="0" :label="$t('m.subscription_closed')"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="contractStartTime">
          <el-col :span="11">
            <el-date-picker v-model="queryModel.contractStartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('m.sign_time')"  style="width:100%"></el-date-picker>
          </el-col>
          <el-col class="fc-text-center" :span="1">~</el-col>
          <el-col :span="11">
            <el-date-picker v-model="queryModel.contractEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('m.sign_time')"  style="width:100%"></el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item>
          <el-col :span="11">
            <el-date-picker v-model="queryModel.applyStartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('m.apply_time')"  style="width:100%"></el-date-picker>
          </el-col>
          <el-col class="fc-text-center" :span="1">~</el-col>
          <el-col :span="11">
            <el-date-picker v-model="queryModel.applyEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('m.apply_time')"  style="width:100%"></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item class="search_form_item">
          <el-select v-model="queryModel.isProhibitLive " :placeholder="$t('m.live_state_placeholder')" clearable>
            <el-option :value="false" :label="$t('m.live_state_open')"></el-option>
            <el-option :value="true" :label="$t('m.live_state_temporary_banned')"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 按钮 -->
      <div class="btn-wrapper">
        <el-button @click="onQueryBtnClick" :disabled='searchBtnTrue' type="primary" size="small">{{$t('m.search')}}</el-button>
        <el-button type="text" size="mini"  @click="resetForm">{{$t('m.reset')}}</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="main_table">
      <el-button @click="doExportUserDate" type="primary" size="small" class="btn-operation" style="margin-bottom: 10px;">{{$t('m.exported_data')}}</el-button>
      <el-table :data="tableData" border style="width: 100%;margin-bottom: 10px;" :row-class-name="tableRowClassName" v-loading="loading.table" ref="tableOrder" :element-loading-text="''"
        element-loading-spinner="el-icon-loading">
        <el-table-column prop="userId" :label="$t('m.live_ID')"></el-table-column>
        <el-table-column prop="nickName" :label="$t('m.sereamer_nickname')"></el-table-column>
        <el-table-column prop="sex" :label="$t('m.gender')">
          <template slot-scope="scope">
            <span v-if="scope.row.sex ===0 ">{{$t('m.female')}}</span>
            <span v-if="scope.row.sex ===1 ">{{$t('m.male')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="img" :label="$t('m.avatar')">
          <template slot-scope="scope">
            <img :src="scope.row.img||require('../../assets/img/photo.png')" class="img-thumb" @click="showPicPreviewDialog(scope.row)">
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('m.remark')" show-overflow-tooltip>
          <template slot-scope="scope">
            <template v-if="scope.row.remark">
              <el-tag size="mini" type="danger" closable
                @close="removeUserRemark(scope.row)">
                <span >{{ scope.row.remark }}</span>
              </el-tag>
            </template>
            <template v-else>
              <el-tag type="info" size="mini">{{$t('m.no_remark')}}</el-tag>
            </template>
            <p>
              <el-tag type="success" size="mini" class="cursor-pointer" @click.native="openUserRemarkDialog(scope.row)">
                <i class="el-icon-plus"></i> {{$t('m.add_remark')}}
              </el-tag>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('m.user_status')">
          <template slot-scope="scope">
            <span v-if="scope.row.status ===1">{{$t('m.normal')}}</span>
            <span v-if="scope.row.status ===2">{{$t('m.temporarily_frozen')}}</span>
            <span v-if="scope.row.status ===3">{{$t('m.permanently_frozen')}}</span>
            <span v-if="scope.row.status ===4">{{$t('m.cancelled')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="birthday" :label="$t('m.birth')"></el-table-column>
        <el-table-column prop="liveId" :label="$t('m.live_room_ID')"></el-table-column>
        <el-table-column prop="fansNum" :label="$t('m.fans_num')"></el-table-column>

        <el-table-column prop="email" :label="$t('m.email')" show-overflow-tooltip>
          <template slot-scope="scope">
            <img width="24" src="../../assets/search.png" @click="getDetailInfo(scope.row,'emailState')" v-if="scope.row.emailState === false">
            <span v-if="scope.row.emailState === true">{{scope.row.email}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="whatsApp" label="WhatsApp">
          <template slot-scope="scope">
            <img width="24" src="../../assets/search.png" @click="getDetailInfo(scope.row,'whatsappState')" v-if="scope.row.whatsappState === false">
            <span v-if="scope.row.whatsappState === true">{{scope.row.whatsApp}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="faceBook" label="Facebook">
          <template slot-scope="scope">
            <img width="24" src="../../assets/search.png" @click="getDetailInfo(scope.row,'facebookState')" v-if="scope.row.facebookState === false">
            <span v-if="scope.row.facebookState === true">{{scope.row.faceBook}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="instagram" label="Instagram">
          <template slot-scope="scope">
            <img width="24" src="../../assets/search.png" @click="getDetailInfo(scope.row,'instagramState')" v-if="scope.row.instagramState === false">
            <span v-if="scope.row.instagramState === true">{{scope.row.instagram}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" :label="$t('m.phone')">
          <template slot-scope="scope">
            <img width="24" src="../../assets/search.png" @click="getDetailInfo(scope.row,'phoneState')" v-if="scope.row.phoneState === false">
            <span class="direction_ltr" v-if="scope.row.phoneState === true">{{scope.row.areaCode?'+'+scope.row.areaCode:''}}{{scope.row.mobile}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="lang" :label="$t('m.mastery_lang')">
          <template slot-scope="scope">
            {{scope.row.lang|langFilt}}
          </template>
        </el-table-column>

        <el-table-column prop="contractStatus" :label="$t('m.sign_status')">
          <template slot-scope="scope">
            <div @click="openSignContractDialog(scope.row)" style="color:#54a8fc; cursor:pointer;">
              <span v-if="scope.row.contractStatus ===1">{{$t('m.sign_ing')}}</span>
              <span v-if="scope.row.contractStatus ===0">{{$t('m.subscription_closed')}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="signDt" :label="$t('m.sign_time')"></el-table-column>
        <el-table-column prop="cancelDt" :label="$t('m.release_time')"></el-table-column>
        <el-table-column prop="applyTime" :label="$t('m.apply_time')"></el-table-column>
        <el-table-column :label="$t('m.live_viola_record')" width="100">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openLiveViolationLogDialog(scope.row)">{{$t('m.view')}}</el-button>
          </template>
        </el-table-column>
        <el-table-column :label="$t('m.live_state_placeholder')" width="100" prop="liveFlagName">
          <!--<template slot-scope="scope">-->
            <!--<div v-if="scope.row.prohibitLive === 2">{{$t('m.live_state_open')}}</div>-->
            <!--<div v-if="scope.row.prohibitLive === 1">{{$t('m.live_state_temporary_banned')}}</div>-->
            <!--<div v-if="scope.row.prohibitLive === 1">{{$t('m.live_banned_time')}}:{{scope.row.hour | liveBannedTrans}}</div>-->
            <!--<div v-if="scope.row.prohibitLive === 1">{{$t('m.live_allowed_time')}}:{{scope.row.prohibitTime}}</div>-->
            <!--<div v-if="scope.row.prohibitLive === 0">{{$t('m.live_state_forever_banned')}}</div>-->
          <!--</template>-->
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination @size-change="onSizeChange" @current-change="onCurrentPageChange" :current-page="pager.page"
        :page-sizes="[10, 20, 30, 100, 300, 500]" :page-size="pager.limit" small layout="total, sizes, prev, pager, next, jumper"
        :total="pager.total" :pager-count="5"></el-pagination>
    </div>
    <!-- 弹窗 -->
    <el-dialog :visible.sync="dialog.picPreview.show" :title="$t('m.preview')" :append-to-body="true">
      <img :src="dialog.picPreview.picSrc" class="img-preview">
    </el-dialog>
    <sign-contract-dialog  @done="query" ref="signContractDialog"></sign-contract-dialog>
    <live-violation-log-dialog  @done="query" ref="liveViolationLogDialog"></live-violation-log-dialog>
    <user-remark-dialog ref="userRemarkDialog" @done="getTableData()"></user-remark-dialog>
  </div>
</template>
<script>
import {
  getAnchorManageList,
  exportUserDate,
  addOrRemoveRemarkInfo
} from '../../api/approval/anchor-approval';
import liveViolationLogDialog from './dialogs/liveViolationLogDialog';
import UserRemarkDialog from './dialogs/UserRemarkDialog';
import signContractDialog from './dialogs/signContractDialog';
import {arrToString} from '../../utils/common';

  // nickName: null,
  // sex: null,
  // status: null,
let queryModelEmpty={
  userId: null,
  remark: null,
  contractStatus: 1,
  contractStartTime: null,
  contractEndTime: null,
  applyStartTime: null,
  applyEndTime: null,
  isProhibitLive: null
}
export default {
  name: 'anchor-approval-page',
  components: {
    'live-violation-log-dialog': liveViolationLogDialog,
    'user-remark-dialog': UserRemarkDialog,
    'sign-contract-dialog': signContractDialog,
  },
  data () {
    return {
      searchBtnTrue: true, // 在生命周期中的列表数据加载完之前搜索按钮是不可点击状态
      guildList: [],
      queryModel: JSON.parse(JSON.stringify(queryModelEmpty)),
      loading: {
        table: true
      },
      pager: {
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      dialog: {
        picPreview: {
          show: false,
          picSrc: null
        },
      },
    }
  },
  filters:{
    langFilt(val){
     return arrToString(val);
    }
  },
  methods: {
    change (e) {
      this.$forceUpdate()
    },
    //重置参数
    resetForm(){
      this.queryModel=JSON.parse(JSON.stringify(queryModelEmpty));
    },
   //切换当前参数显示隐藏
    getDetailInfo(row,e) {
      var index = row.index;
      row[e] = true;
      this.$set(this.tableData, index, row);
      this.tableData = this.tableData;
    },
    tableRowClassName({row,column,rowIndex}) {
      row.index = rowIndex;
    },
    getWechat(row) {
      console.log(row);
      var index = row.index;
      row.wechatState = true;
      this.$set(this.tableData, index, row);
    },
    getPhone(row) {
      var index = row.index;
      row.phoneState = true;
      this.$set(this.tableData, index, row);
    },
    showPicPreviewDialog(row) {
      if(row.img){
        this.dialog.picPreview.picSrc = row.img;
        this.dialog.picPreview.show = true;
      }

    },
    activeInputElement() {
      document.activeElement.blur();
      this.$nextTick(() => {
          let inputTime = document.querySelectorAll('.el-input__inner')
          inputTime.forEach(item => {
            item.addEventListener('focus', () => {
              document.activeElement.blur()
            })
          })
        })
    },
    openUserRemarkDialog(row) {
      this.$refs.userRemarkDialog.showDialog(row);
    },
    removeUserRemark(row) {

      /*
      // 因为没有多语言，先暂时删掉的
      this.$confirm(
        `此操作将移除该用户 ${row.userId}下的 ${row.remark}, 是否继续?`,
        this.$t('m.tip'),
        {
          type: "warning"
        }
      )
        .then(() => {

        })
        .catch(() => {}); */

      let model = {
        remarkType: 0, //0删除备注 1新增备注
        id: row.id,
        remark: row.remark
      }
      addOrRemoveRemarkInfo(model)
        .then(resp => {
          this.$message.success(this.$t('m.oper_success'));
          this.getTableData();
        })
        .catch(errorMsg => {});
   },
    openLiveViolationLogDialog(row) {
      this.$refs.liveViolationLogDialog.showDialog(row);
    },
    openSignContractDialog(row) {
      this.$refs.signContractDialog.showDialog(row);
    },

    onQueryBtnClick() {
      this.pager.page = 1;
      this.$refs.tableOrder.clearSort();
      this.query();
    },
    query() {
      this.loading.table = true;
      this.getTableData();
    },
    onSizeChange(size) {
      this.pager.limit = size;
      this.query();
    },
    onCurrentPageChange(page) {
      this.pager.page = page;
      this.query();
    },
    getTableData() {
      // 显示表格loading
      this.loading.table = true;
      getAnchorManageList({
        query: this.queryModel,
        pager: this.pager,
        sorter: this.sorter
      })
        .then(({ data }) => {
          let list = data.data.list;
          list.forEach(item => {
            item.emailState = false;
            item.phoneState = false;
            item.whatsappState = false;
            item.facebookState = false;
            item.instagramState = false;
            item.phoneState = false;
          })
          this.tableData=list;
          console.log(this.tableData);
          this.pager.total = data.data.total;
          // 取消loading状态
          this.loading.table = false;
          this.searchBtnTrue = false;
        })
        .catch(error => {
          this.loading.table = false;
        });
    },
    // 导出数据
    doExportUserDate() {
      this.$confirm(this.$t('m.exported_data')+'?', {
        type: "info"
      })
        .then(() => {
          this.queryModel.exportFileName = "exportFileUserDate";
          exportUserDate(this.queryModel).then(resp => {
              let a = document.createElement('a');
              let blob = new Blob([resp.data], {type: "application/vnd.ms-excel"}); // 指定文件MIME
              a.style.display = "none";
              a.setAttribute('download', 'test');
              a.download = 'anchor'; // 指定下载的文件名
              a.href = window.URL.createObjectURL(blob); // URL对象
              document.body.appendChild(a);
              a.click(); // 模拟点击
              URL.revokeObjectURL(blob);
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
  },
  created() {
    this.getTableData();
  }
}
</script>
<style lang="less" scoped>
  .main_form {
    margin-bottom: 16px;
    padding: 16px;
    background-color: #FFFFFF;
  }

  .main_table {
    padding: 16px;
    background-color: #FFFFFF;
  }
.btn-wrapper{
  /* margin-bottom:20px; */
  min-height:40px;
}
.btn-operation {
  float: right;
}
.ar{
  .btn-operation{
    float: left;
  }
}
/* .el-date-editor.el-input {
  width: 188px;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.coldiv {
  line-height: 2.1;
}
@media screen and (max-width: 1200px) {
  .el-date-editor.el-input {
    width: 155px;
  }
}
@media screen and (max-width: 991px) {
  .coldiv {
    margin-left: 0px;
  }
  .el-date-editor.el-input {
    width: 144px;
  }
}
@media screen and (max-width:768px) {
	.el-date-editor.el-input {
    width: 133px;
	}
}
@media screen and (max-width: 640px) {
	.el-date-editor.el-input {
	  width: 160px;
	}
}
@media screen and (max-width: 480px) {
	.coldiv {margin-left: -5px;}
  .el-date-editor.el-input {
    width: 145px;
  }
} */
</style>



// WEBPACK FOOTER //
// src/pages/approval/anchorApprovalPage.vue